import { useState, useEffect, useCallback, useRef } from 'react';

export const useExpandableTruncation = ref => {
    const [wasTruncated, setWasTruncated] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const skipNextCheck = useRef(false);

    const checkTruncation = useCallback(() => {
        if (skipNextCheck.current) {
            skipNextCheck.current = false;
            return;
        }

        if (!ref.current) return;

        const { offsetHeight, scrollHeight } = ref.current;
        setWasTruncated(scrollHeight > offsetHeight);
        setIsExpanded(false);
    }, [ref]);

    useEffect(() => {
        checkTruncation();

        if (!ref.current) return;

        const observer = new ResizeObserver(() => {
            checkTruncation();
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [ref, checkTruncation]);

    const toggleExpand = useCallback(() => {
        skipNextCheck.current = true;
        setIsExpanded(prev => !prev);
    }, []);

    return {
        isTruncated: wasTruncated,
        isExpanded,
        toggleExpand
    };
};
